import { getResultFromResponse, runAsyncSafe } from '@web3/utils';
import { getStakingTaskList } from '../api';
import { StakingTask } from '../types';
import { EventBasedStore } from '../utils/EventBasedStore';

class StakingLatestTaskStore extends EventBasedStore<{
  loading: boolean;
  activity?: StakingTask;
}> {
  constructor() {
    super({ loading: false }, undefined, () => this.getStakingTask());
  }

  async getStakingTask() {
    if (this.state.loading) {
      return;
    }
    this.setState({ loading: true });
    const [, res] = await runAsyncSafe(getResultFromResponse(getStakingTaskList()));
    this.setState({
      loading: false,
      activity: res || undefined,
    });
  }
}

export const latestStakingStore = new StakingLatestTaskStore();
